module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/wigilia/big/46-b36da65aee5db8307449f6ab54246fe3.webp";